import { render, staticRenderFns } from "./NotificationBellMessage.vue?vue&type=template&id=7215c62f&scoped=true&"
import script from "./NotificationBellMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationBellMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBellMessage.vue?vue&type=style&index=0&id=7215c62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215c62f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7215c62f')) {
      api.createRecord('7215c62f', component.options)
    } else {
      api.reload('7215c62f', component.options)
    }
    module.hot.accept("./NotificationBellMessage.vue?vue&type=template&id=7215c62f&scoped=true&", function () {
      api.rerender('7215c62f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/NotificationBell/NotificationBellMessage.vue"
export default component.exports